// ##### 24-06-13 Komarov
import { DownOutlined } from '@ant-design/icons';
// ##### Komarov 2025-07-18
import React from 'react';
import { Media } from '../../../../../helpers/MediaConfig.js';
// ##### Komarov 2025-07-18
import { useDispatch, useSelector } from 'react-redux';
import { getPax } from '../../../../../Redux/actions/paxchoice.js';
import Pax from '../../../../Library/Icons/pax.jsx';

// ##### 23-11-03 Komarov

// ##### Komarov 2025-07-18
const PaxValue = ({ style = null }) => {
  const { adults: counterAdults, children: counterChild, rooms: counterRooms } = useSelector(state => state.paxchoice.pax);

  // ##### Komarov 2025-08-05
  const Adults = useSelector(state => state.pagesRedux[state.language]?.Adults || '');
  const Children = useSelector(state => state.pagesRedux[state.language]?.Children || '');
  const Rooms = useSelector(state => state.pagesRedux[state.language]?.Rooms || '');

  // ##### Komarov 2025-07-18
  const dispatch = useDispatch();

  // ##### Komarov 2025-07-18
  const TotalPax = () => {
    dispatch(getPax(counterAdults, counterChild, counterRooms));
  };

  // ##### 24-01-31 Komarov
  return (
    <div
      data-component="PaxValue"
      style={style}
      onClick={TotalPax}
      onKeyDown={e => {
        // Trigger click action on Enter key press
        if (e.key === 'Enter') {
          TotalPax(e);
        }
      }}
    >
      <Pax />
      <div style={{ paddingLeft: '1vw', alignContent: 'center' }}>
        <center>
          {/* ##### 22-11-14 Komarov */}
          <b>{counterAdults}</b>
          <span style={{ marginLeft: '0.3rem' }} />
          {
            // ##### 23-10-04 Komarov
            Adults
          }
          ,
        </center>
      </div>
      <div style={{ paddingLeft: '1vw' }}>
        <center>
          {/* ##### 23-03-01 Komarov */}
          <b>{counterChild}</b>
          <span style={{ marginLeft: '0.3rem' }} />
          {
            // ##### 23-10-04 Komarov
            Children
          }
          ,
        </center>
      </div>
      <div style={{ paddingLeft: '1vw' }}>
        <center>
          <b>{counterRooms}</b>
          <span style={{ marginLeft: '0.3rem' }} />
          {
            // ##### 23-10-04 Komarov
            Rooms
          }
        </center>
      </div>
      {/* ##### 23-11-03 Komarov */}
      <Media greaterThanOrEqual="Laptop-1024-1440">
        <DownOutlined className="DownOutlined" />
      </Media>
      <Media lessThan="Laptop-1024-1440">
        <DownOutlined className="DownOutlined_SmallPortrait" />
      </Media>
    </div>
  );
};

export default PaxValue;
